import { ProductViewConfigurator } from '~/types/configurator';

let label;

export default {
    controls: [
        {
            key: 'material',
            keyLabel: 'material',
            label: 'Material',
            choices: [
                {
                    label: (label = 'Aluminum'),
                    detailsModalLabel: label,
                    value: 'aluminum',
                },
            ],
            hideOnProductPage: true,
        },
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            choices: [
                {
                    label: (label = 'Silver and Blue'),
                    detailsModalLabel: label,
                    value: 'silver-and-blue',
                },
            ],
            hideOnProductPage: true,
        },
        {
            key: 'weight',
            keyLabel: 'weight',
            label: 'Weight',
            choices: [
                {
                    label: (label = '3.6lb'),
                    detailsModalLabel: label,
                    value: '3_6lb',
                },
            ],
            hideOnProductPage: true,
        },
    ],
} as ProductViewConfigurator;
